class httpErrorController {
    constructor($window) {
        'ngInject';
        this.$window = $window;
    }
}

export default httpErrorController;



// WEBPACK FOOTER //
// ./src/app/angular/http-error/http-error.controller.js